var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8469 12.6466L15.9746 12.0935C16.081 11.6344 15.8431 11.1657 15.4083 10.975L12.0188 9.52161C11.6194 9.35174 11.1534 9.46618 10.8791 9.80208L10.3484 10.4465L15.8469 12.6466ZM4.60773e-09 1.70286C-4.37454e-05 9.58411 6.4125 15.9997 14.2969 15.9997C14.7547 15.9997 15.1472 15.6882 15.2487 15.2429L15.5418 13.9722L9.50119 11.4838C7.3375 10.4216 5.57812 8.66224 4.51562 6.47161L2.0275 0.458175L0.756875 0.7513C0.311469 0.853488 -4.37454e-05 1.24443 4.60773e-09 1.70286ZM6.19688 5.12161C6.53375 4.85014 6.65031 4.38193 6.4775 3.98255L5.025 0.590988C4.8375 0.156519 4.3625 -0.0805123 3.87812 0.0248877L3.35313 0.152363L5.55 5.64974L6.19688 5.12161Z",
    fill: "#9498AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5413 13.9718L15.8471 12.6465L10.3753 10.4465L9.52839 11.4833L15.5413 13.9718ZM4.51632 6.47178L5.5507 5.6499L3.35382 0.152527L2.0282 0.458339L4.51632 6.47178Z",
    fill: "#9498AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a3ccbc0eb42106a057d72bb5e4c26dbb.svg";
export { ForwardRef as ReactComponent };